'use client'

import { useEffect, useState } from 'react'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const calculateProgress = (targetDate: Date) => {
  const now = dayjs.utc()
  const targetTime = dayjs.utc(targetDate)
  const startTime = dayjs.utc(targetTime).subtract(14, 'days')

  const totalTime = targetTime.diff(startTime, 'seconds')
  const remainingSeconds = Math.max(0, targetTime.diff(now, 'seconds'))

  return ((remainingSeconds / totalTime) * 100).toFixed(0) ?? 0
}

type HeaderRewardsDropdownBonusDepositCircularCountdownType = {
  size?: number
  targetDate: Date
}

export default function HeaderRewardsDropdownBonusDepositCircularCountdown({
  size = 98,
  targetDate,
}: HeaderRewardsDropdownBonusDepositCircularCountdownType) {
  const [progress, setProgress] = useState('0')

  useEffect(() => {
    setProgress(calculateProgress(targetDate))

    const interval = setInterval(() => {
      setProgress(calculateProgress(targetDate))
    }, 1000)

    return () => clearInterval(interval)
  }, [targetDate])

  return (
    <div
      className='rewards-dropdown-bonus-deposit__timer-box__circular-progress'
      style={{
        backgroundImage: `conic-gradient(from 90deg, #c9bacc ${progress}%, #5b6ce7 ${progress}%)`,
        maskImage: 'url(/assets/segmented-circle.png)',
        maskPosition: 'center',
        maskSize: '100%',
        height: size,
        width: size,
      }}
    ></div>
  )
}
